import { useState } from "react";
import { Minus, Plus } from "@phosphor-icons/react";

export const FAQ = ({ items, defaultOpen = 0, prefix = "faq" }) => {
  const [open, setOpen] = useState(defaultOpen);
  return (
    <div className="space-y-3">
      {items.map((f, i) => {
        const isOpen = open === i;
        return (
          <div key={f.q} className="glass rounded-2xl overflow-hidden" data-testid={`${prefix}-item-${i}`}>
            <h3 className="m-0">
              <button
                type="button"
                className="w-full flex items-center justify-between gap-4 p-5 text-left"
                aria-expanded={isOpen}
                aria-controls={`${prefix}-answer-${i}`}
                onClick={() => setOpen(isOpen ? -1 : i)}
                data-testid={`${prefix}-toggle-${i}`}
              >
                <span className="font-display font-semibold text-base sm:text-lg">{f.q}</span>
                <span className="shrink-0 w-7 h-7 rounded-full flex items-center justify-center border" style={{ borderColor: "rgba(0,191,255,.35)", background: "rgba(0,191,255,.06)" }} aria-hidden="true">
                  {isOpen ? <Minus size={14} className="text-[#00BFFF]" /> : <Plus size={14} className="text-[#00BFFF]" />}
                </span>
              </button>
            </h3>
            <div id={`${prefix}-answer-${i}`} hidden={!isOpen} className="px-5 pb-5 text-sm text-slate-300 leading-relaxed">{f.a}</div>
          </div>
        );
      })}
    </div>
  );
};
